export default __webpack_public_path__ + "static/media/p4.faea9f2e.png";